import React from 'react'
import ReactDOM from 'react-dom'
import VirtualPortal from './components/VirtualPortal'
import App from './components/App'
import 'bootstrap/dist/css/bootstrap.min.css'
import './components/VirtualPortal/css/index.scss'

// This will probably need to be changed back before we deploy
// to an actual production but doing this during development
// will likely take care of a host of caching issues for now
// import { unregister } from './registerServiceWorker'
// import registerServiceWorker from './registerServiceWorker';
// TODO work on stage.
//

if ((!window.location.pathname.includes('wizard')) && (!window.location.host.includes('virtual'))) {
  if (process.env.REACT_APP_CURRENT_ENV === 'development') {
    window.location.assign('http://localhost:1340')
  } else if(process.env.REACT_APP_CURRENT_ENV === 'staging'){
    window.location.assign('https://qa-my.evanta.com/')
  } else {
    window.location.assign('https://my.evanta.com')
  }
}

// add this here to avoid jumpy redirect
if ((window.location.pathname.includes('wizard')) || (window.location.host.includes('virtual'))) {
  const urlParams = new URLSearchParams(window.location.search)
  window.visitingOneOnOneWizardFrom = urlParams.get('wizard_from')
  // if user is coming to app via forgot password link, automatically rmv credentials
  if (window.location.href.indexOf('forgot_password') > -1) {
    localStorage.removeItem('credentials')
  }
  if (window.isVirtualPortal || window.visitingOneOnOneWizardFrom) {
    ReactDOM.render(<VirtualPortal token={ window.location.pathname.split('/')[1] } />, document.getElementById('root'))
  } else {
    ReactDOM.render(<App />, document.getElementById('root'))
  }
}




// This will probably need to be changed back before we deploy
// to an actual production but doing this during development
// will likely take care of a host of caching issues for now
// EH July 20th
// unregister()
// registerServiceWorker();
